/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: oujinfa oujinfa@100efly.com
 * @Date: 2024-01-25 10:26:05
 * @LastEditTime: 2024-04-29 15:08:14
 * @Descripttion: file content
 */
export const PRODUCT = 'bingo'

export const VERSION = '0.0.0'

// oss 链接
const URL = 'https://res.100efly.com/bingo/teacher/res/oem/'
export const BASE_URL = URL + PRODUCT + '/'
export const URL_COMM = URL + 'comm/'
